import { HTMLAttributes } from 'react'

import HeroOnlyText from '@/components/sections/HeroOnlyText'
import HeroResize from '@/components/sections/HeroResize'

import { WPImage, WPPageData, WPVideo } from '@/types'

export type HeroProps = HTMLAttributes<HTMLElement> &
  Partial<{
    headline: string
    only_text: boolean
    is_text_big: boolean
    poster: {
      desktop: WPImage
      mobile: WPImage
      hasVideo: boolean
    }
    video: {
      desktop: WPVideo
      mobile: WPVideo
    }
    paragraph: {
      label: string
      title: string
      text: string
      cta: {
        url: string
        title: string
        target: string
      }
    }
    theme: WPPageData['acf']['hero']['theme']
  }>

const Hero = ({ ...props }: HeroProps) => {
  return props.only_text ? (
    <HeroOnlyText headline={props.headline} theme={props.theme} />
  ) : (
    <HeroResize
      image={props?.poster?.desktop}
      image_desktop={props?.poster?.desktop}
      image_mobile={props?.poster?.mobile}
      pretitle={props?.paragraph?.label}
      title={props?.paragraph?.title}
      text={props?.paragraph?.text}
      link={props?.paragraph?.cta}
      theme="light"
      alignment="left"
      is_text_big={props?.is_text_big}
      is_boxed={false}
      use_square_layout={false}
    />
  )
}

export default Hero
